<app-cyclops-nav></app-cyclops-nav>
<app-cyclops-header></app-cyclops-header>
<!-- <app-cyclops-schedule></app-cyclops-schedule> -->

<app-cyclops-about></app-cyclops-about>
<!-- <app-cyclops-workout-about></app-cyclops-workout-about> -->
<!-- <app-cyclops-counter></app-cyclops-counter> -->
<!-- <app-cyclops-testimonial></app-cyclops-testimonial> -->
<!-- <app-cyclops-pricing></app-cyclops-pricing> -->
<app-cyclops-bmi></app-cyclops-bmi>
<!-- <app-cyclops-trainer></app-cyclops-trainer> -->
<app-cyclops-brand></app-cyclops-brand>
<app-cyclops-footer></app-cyclops-footer>
<app-cyclops-copyright></app-cyclops-copyright>
